import { Component, Mixins } from "vue-property-decorator";
import ModuleTypology from "@/mixins/http/ModuleTypology";
import store from "@/store";

@Component
class ModuleTypologiesService extends Mixins(ModuleTypology) {
  created() {
    this.$store = store;
  }
}

export default new ModuleTypologiesService();
